export default __webpack_public_path__ + "static/media/homebanner.64fc550e.png";